import Constants from '@/Constants';
import { CategoryRequest } from '@/models/Category';
import http from '@/services/HttpService';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { addContentListByCategory } from '../item/action';
import { addCourseListByCategory } from '../list/action';
import { addProgramByCategory } from '../program/action';
import { getCategoriesFailure, getCategoriesSuccess, getCategoryFailure, getCategorySuccess } from './action';
import { CategoryTypes } from './types';

export function* getCategories(action: PayloadAction<CategoryTypes.GET_CATEGORIES_REQUEST, CategoryRequest>) {
    try {
        const getQueryParams = () => {
            const {
                applicationId,
                orgId: organizationId,
                locale,
                onlyIfHasCourseOrContent: withCoursesAmount,
                onlyInactive,
                offset,
                limit,
                name,
            } = action.payload;

            const queryParams = {
                applicationId,
                organizationId,
                locale,
                withCoursesAmount,
                onlyInactive,
                offset,
                limit,
                name,
            };

            return Object.entries(queryParams)
                .filter(([, value]) => !!value)
                .map(([key, value]) => `${key}=${value}`)
                .join('&');
        };

        const { data, headers } = yield call(http.get, `${Constants.CATEGORIES_URI}?${getQueryParams()}`);

        yield put(getCategoriesSuccess(data, headers.total || 0));
    } catch (err) {
        yield put(getCategoriesFailure(err as any));
    }
}

export function* getCategory(action: PayloadAction<CategoryTypes.GET_CATEGORY_REQUEST, number>) {
    try {
        const { data } = yield call(http.get, `${Constants.CATEGORIES_URI}/${action.payload}`);
        yield put(addCourseListByCategory(action.payload));
        yield put(addContentListByCategory(action.payload));
        yield put(addProgramByCategory(action.payload));
        yield put(getCategorySuccess(data));
    } catch (err) {
        yield put(getCategoryFailure(err as any));
    }
}
